import React, { useEffect, useState } from 'react'
import { Toast } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { MedicalDetails, RegisterHeader } from '../../../Components/Index'
import './MedicalSlip.scss'
import { Loader } from '../../../../../Components'
import userService from '../../../../../Services/userService'
import { USER_FAILURE, USER_SUCCESS } from '../../../../../Constants/UserConstants'
import Footer from '../../../../../Layout/Footer'

const MedicalSlip = () => {
  const { refid } = useParams<any>()
  const dispatcher = useDispatch();

  // eslint-disable-next-line no-unused-vars
  const [disableStatus, setDisableStatus] = useState(false)
  const [values, setValue] = useState<any>()
  const [loader, setLoader] = useState(false)

  const { success, loading } = useSelector((state: { user:any }) => state.user)

  useEffect(() => {
    if (typeof success === "undefined" && typeof success !== "object") {
      setLoader(true)
      userService.getDataMedical(refid).then((res:any) => {
        setLoader(false)
        dispatcher({ type: USER_SUCCESS, data: res.data });
        setValue(res.data)
      }, (error: {messgae: string}) => {
        dispatcher({ type: USER_FAILURE, data: error.messgae });
        window.location.href = "/"
      })
    }
  }, [])

  if (loading && loading === true) {
    setLoader(true)
  }

  useEffect(() => {
    if (typeof success !== "undefined") {
      setValue(success)
    }
  }, [success])

  return (
    <div className="confirmation bg-light">
      <div className="register-main">
        <RegisterHeader></RegisterHeader>
          <div className="container">
              <div className="register-inner">
                  <div className="spacer"></div>

                  {values && Object.keys(values).length !== 0 && values !== undefined && (<>
                    <MedicalDetails value={values} disable={disableStatus}/>
                  </>)}
                  <div className="card">
                    <div className="card-body text-center">
                    <button onClick={() => window.print()} className="btn btn-dark"> Print Slip </button>
                    </div>
                  </div>
              </div>
        <Toast/>
      </div>
          <Footer/>
    </div>
    <Loader show={loader}/>
  </div>
  )
}

export default MedicalSlip
